<template functional>
  <MaterialCard
    :class="[data.class, data.staticClass]"
    :style="[data.style, data.staticStyle]"
    v-bind="data.attrs"
    v-on="listeners"
  >
    <v-form>
      <v-container py-0>
        <v-layout wrap>
          <v-flex
            xs12
            md4
          >
            <v-text-field
              :value="props.sensor.id"
              class="purple-input"
              label="id"
              readonly
            />
          </v-flex>
          <v-flex
            xs12
            md4
          >
            <v-text-field
              :value="props.sensor.serialNo"
              class="purple-input"
              label="シリアルNo"
              readonly
            />
          </v-flex>
          <v-flex
            xs12
            md4
          >
            <v-text-field
              v-model="props.sensor.sensorId"
              class="purple-input"
              label="通信ID"
              readonly
            />
          </v-flex>
          <v-flex
            xs12
            md4
          >
            <v-text-field
              value="C01"
              class="purple-input"
              label="センサータイプ"
              readonly
            />
          </v-flex>
          <v-flex xs12>
            <v-textarea
              v-model="props.sensor.remarks"
              class="purple-input"
              label="備考"
            />
          </v-flex>
          <v-flex
            xs12
            text-xs-right
          >
            <v-btn
              class="mx-0 font-weight-light"
              color="success"
              disabled
            >
              登録
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </MaterialCard>
</template>

<script>
export default {
  props: {
    sensor: {
      type: Object,
      default: () => null
    },
    customer: {
      type: Object,
      default: () => null
    }
  }
}
</script>

<style>

</style>
